import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import raf from '@/plugins/raf'
import api from '@/plugins/api'
import tools from '@/plugins/tools'
import scroll from '@/plugins/scroll'
import AxeptioPlugin from '@/plugins/axeptio'


import 'babel-polyfill'
import 'dom-shims'

import VueHead from 'vue-head'
// import VueAnalytics from 'vue-analytics'

import VueScrollTo from 'vue-scrollto'

// prismic cms
import PrismicVue from '@prismicio/vue'
// repository endpoint
const endpoint = 'https://sbbs.cdn.prismic.io/api/v2'
Vue.use(PrismicVue, {
  endpoint ,
  apiOptions: { accessToken: 'MC5aR1ZGQWhBQUFDRUFkNVV2.77-9KiPvv71y77-977-977-977-977-977-977-9Km7vv73vv70xV2kfCe-_vTfvv71kCO-_ve-_ve-_ve-_ve-_vTY' },
})


Vue.use(raf)
Vue.use(tools)
Vue.use(scroll)
Vue.use(api)
Vue.use(AxeptioPlugin)

Vue.config.productionTip = false

Vue.use(tools)
Vue.use(scroll)
Vue.use(VueHead)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 900,
  easing: "easeOut",
  offset: -130,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

// Vue.use(VueAnalytics, {
//   id: 'UA-XXXXXXX-1',
//   router
// })

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#Site')
